import { render, staticRenderFns } from "./WeekView.vue?vue&type=template&id=b8a559a8"
import script from "./WeekView.vue?vue&type=script&lang=js"
export * from "./WeekView.vue?vue&type=script&lang=js"
import style0 from "./WeekView.vue?vue&type=style&index=0&id=b8a559a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports